export const Skeleton = ({ width = '100%', height = '20px', className = '' }: { width?: string; height?: string; className?: string }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} style={{ width, height }} />
);

export const SkeletonCard = () => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex flex-col gap-3">
    <Skeleton width="60%" height="14px" />
    <Skeleton width="80%" height="32px" />
    <Skeleton width="40%" height="12px" />
  </div>
);

export const SkeletonTable = ({ rows = 5 }: { rows?: number }) => (
  <div className="flex flex-col gap-1">
    <Skeleton height="36px" />
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} height="28px" />
    ))}
  </div>
);
